import { BasicLayout } from '../../../components/BasicLayout';
import { SetNewPasswordFormValues } from '../../../../types/ui';
import SetNewPasswordForm from './SetNewPasswordForm';
import useSetNewPassword from './useSetNewPassword';

const SetNewPasswordScene = () => {
  const { setNewPassword, status } = useSetNewPassword();

  const setNewPasswordSubmitted = (values: SetNewPasswordFormValues) => {
    setNewPassword(values.newPassword, values.reenterNewPassword);
  };

  const isLoading = status === 'loading';

  return (
    <BasicLayout>
      <SetNewPasswordForm
        onSubmit={setNewPasswordSubmitted}
        isLoading={isLoading}
      />
    </BasicLayout>
  );
};

export default SetNewPasswordScene;
